import React, { Component } from 'react';
import { ShowExpanded } from '../shared';

class ContactComment extends Component {
  constructor() {
    super();
    this.state = { expanded: false };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState(state => ({ expanded: !state.expanded }));
  }
  render() {
    const { comment } = this.props;
    const { expanded } = this.state;

    if (!comment) {
      return null;
    }

    let lines = comment.split('\n');
    let hasMore = lines.length > 1;
    if (hasMore && !expanded) {
      lines = [ lines[0] ];
    }

    return (
      <div className="form-group comment">
        <label onClick={this.toggle}>
          <ShowExpanded expanded={expanded} />
          Notitie:
        </label>
        <div>
          {lines.map((t, i) => <span key={i}>{t}<br /></span>)}
        </div>
      </div>
    );
  }
}

export default ContactComment;



// WEBPACK FOOTER //
// ./src/contacts/ContactComment.js